"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _trayMenu = _interopRequireDefault(require("@ux/tray-menu"));
var _markets = require("@godaddy/markets");
var _util = require("@ux/util");
var _golfToEid = _interopRequireDefault(require("golf-to-eid"));
var _reactMintl = require("@godaddy/react-mintl");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Render and expose the CurrencySelector as a functional Component. The CurrencySelector
 * is responsible for allowing users to select their desired money. The default values
 * populated and the ordering of currencies within the list are dependent on the current
 * market and any previous user state.
 *
 * @param {Object} props Properties
 * @api public
 */
class CurrencySelector extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      priorityCurrencies: [],
      currencies: [],
      selected: '',
      loaded: false
    };
  }

  /**
   * Function that gets called when user clicks on a currency item
   *
   * @param {Currency} cur The currently selected currency object
   * @param {React.SyntheticEvent} event The event fired on click
   *
   * @api public
   */
  onCurrencyChanged(cur, event) {
    event.preventDefault();
    this.setState({
      currency: cur,
      selected: cur.code
    });
    this.tray.close();
    if (typeof document === 'undefined') {
      return;
    }
    this.doCurrencyRedirect(cur);
  }

  /**
   * Do currency redirect once set
   *
   * @param {Currency} cur The currently selected currency object
   */
  doCurrencyRedirect(cur) {
    const {
      isReseller,
      urls,
      privateLabelId
    } = this.props;
    if (isReseller) {
      const url = new _util.URL(urls.currencyList.href, true);
      url.set('query', _objectSpread(_objectSpread({}, url.query), {}, {
        currency: cur.code,
        target: window.location.href
      }));
      window.location.assign(url.href);
      return;
    }
    const requestUrl = new _util.URL(urls.currencyList.href + '/' + cur.code);
    const query = {};
    if (privateLabelId !== 1) {
      query.pl_id = privateLabelId;
    }
    requestUrl.set('query', query);
    _util.request.get(requestUrl.href, {}, err => {
      if (err) {
        return;
      }
      const redirectUrl = new _util.URL(window.location.href, true);
      if (redirectUrl.query.currency) {
        // strip `currencyType` query
        redirectUrl.set('query', _objectSpread(_objectSpread({}, redirectUrl.query), {}, {
          currency: ''
        }));
        // If the URL is changing, we must truly redirect to it
        window.location.assign(redirectUrl.href);
      } else {
        // If the URL is the same, we can simply reload, so that hash URLs work
        window.location.reload(true);
      }
    });
  }

  /**
   * @typedef {Object} Currency
   * @prop {string} code Currency code (e.g. USD, EUR)
   * @prop {string} symbol Currency symbol (e.g. $, £, ¥)
   */
  /**
   * Performs lexographic sorts based on the `code` key.
   * @param {Currency} lcur LHS of the sort to compare.
   * @param {Currency} rcur RHS of the sort to compare.
   * @returns {Number} A value indicating if `lcur.code` is greater than,
   * less than, or equal to `rcur.code`.
   * @api private
   */
  sortByCode(lcur, rcur) {
    const lcode = lcur.code;
    const rcode = rcur.code;
    if (lcode === rcode) {
      return 0;
    }
    return lcode > rcode ? 1 : -1;
  }

  /**
   * Perform an AJAX call to the GUI service and pass the set
   * the currencies represented by the results on this instance.
   * @param {Function} [done] Optional continuation callback
   * @api public
   */
  fetchCurrencies(done) {
    // TODO (crobbins): either introduce a second GUI string
    // for the base host or move this safety check into @godaddy/markets
    const gui = this.props.urls.gui.href.replace(/pcjson.*$/, '');
    // ux.eldorado.data.currency passed in by CMS
    let selected = this.props.currency;
    // string value of the `currency` cookie
    const currencyCookie = _util.cookie.get('currency');
    const {
      market,
      privateLabelId
    } = this.props;
    this.getCurrencies(gui, market, privateLabelId, (err, results) => {
      if (err) {
        return;
      }
      // If we received an array as a result then normalize the
      // individual items to the data structure we expect:
      // { code: 'USD', symbol: '$' }
      // also validate the currency cookie data
      results = (results || []).map(cur => {
        if (cur.currencytype === currencyCookie) {
          selected = cur.currencytype;
        }
        return {
          code: cur.currencytype,
          symbol: cur.symbol
        };
      });
      this.setCurrencies(results, selected, done);
    });
  }

  /**
   * @typedef {import('@godaddy/markets/lib/currencies').getCurrenciesCallback} getCurrenciesCallback
   */
  /**
   * Wrapper around getCurrencies from @godaddy/markets to allow easier stubbing in tests
   * @param {string} gui GUI URL
   * @param {string} market Market code
   * @param {number} privateLabelId Private label ID
   * @param {getCurrenciesCallback} done Continuation callback
   */
  getCurrencies(gui, market, privateLabelId, done) {
    (0, _markets.getCurrencies)(gui, market, privateLabelId, done);
  }

  /**
   * Populate state with a list of currencies (from the Markets API).
   * @param {Currency[]} results List of unique currencies (e.g. { code: CAD, symbol: '$' })
   * @param {string} selected The currency code of the currency selected by the currency cookie
   * @param {Function} [done] Optional continuation callback
   * @api private
   */
  setCurrencies(results, selected, done) {
    // Find the currency object in the results associated with the currentMarket.
    // n.b.: assumes currencies returned by `results` have unique codes
    // and that the gui api returns them in order.

    // Build array of priority currency objects by cloning the currencies
    // that come before `-` in `results`
    const priority = [];
    const currencies = [];
    let isPriority = true;
    results.forEach(cur => {
      if (cur.symbol === '-') {
        isPriority = false;
        return;
      }
      if (isPriority) {
        priority.push(cur);
      } else {
        currencies.push(cur);
      }
    });
    this.setState({
      currencies: currencies,
      priorityCurrencies: priority,
      selected: selected || 'USD',
      loaded: true
    }, done);
  }

  /**
   * Fetches the list of currencies from the GUI service if no
   * currencies are present.
   * @api private
   */
  componentDidMount() {
    const {
      loaded
    } = this.state;
    if (typeof document !== 'undefined' && !loaded) {
      this.fetchCurrencies();
    }
  }

  /**
   * Renders the CurrencySelector as a TrayMenu composed of two sets
   * of CurrencyItems:
   * - priorityCurrencies: currencies that should be displayed first.
   * - currencies: all other currencies available to transact in.
   *
   * @returns {React.ReactElement} Virtual DOM for the CurrencySelector
   * @api public
   */
  render() {
    // Do not render anything if the currencies are not yet fetched
    if (!this.state.loaded) return null;
    const {
      currencies,
      priorityCurrencies,
      selected
    } = this.state;
    const {
      eidPrefix,
      messages
    } = this.props;
    const trayMenuClassNames = (0, _classnames.default)('currency-selector', 'currency-selector-fade', {
      ['currency-selector-in']: this.state.loaded
    });
    const eid = (0, _golfToEid.default)('CurrencySelector', {
      prefix: eidPrefix,
      postfix: 'click'
    });
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      messages: messages
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Sales:Footer:CurrencySelector:Label",
      values: {
        selection: selected
      }
    }, content => /*#__PURE__*/_react.default.createElement(_trayMenu.default, {
      ariaLabel: content,
      name: selected,
      type: "base",
      className: trayMenuClassNames,
      ref: c => this.tray = c,
      "data-eid": eid
    }, priorityCurrencies.map((cur, i) => {
      const classNames = (0, _classnames.default)('currency-item', {
        selected: selected === cur.code
      });
      return /*#__PURE__*/_react.default.createElement(CurrencyItem, {
        key: `priority-${i}`,
        code: cur.code,
        symbol: cur.symbol,
        className: classNames,
        eidPrefix: eidPrefix,
        onClick: this.onCurrencyChanged.bind(this, cur)
      });
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "divider"
    }), currencies.map((cur, i) => {
      const classNames = (0, _classnames.default)('currency-item', {
        selected: selected === cur.code
      });
      return /*#__PURE__*/_react.default.createElement(CurrencyItem, {
        key: `currency-${i}`,
        code: cur.code,
        symbol: cur.symbol,
        className: classNames,
        eidPrefix: eidPrefix,
        onClick: this.onCurrencyChanged.bind(this, cur)
      });
    }))));
  }
}

/*
 * PropTypes for the CurrencySelector. `urls.gui` is the only
 * required URL.
 */
CurrencySelector.propTypes = {
  messages: _propTypes.default.object.isRequired,
  currency: _propTypes.default.string,
  eidPrefix: _propTypes.default.string,
  urls: _propTypes.default.object.isRequired,
  market: _propTypes.default.string.isRequired,
  privateLabelId: _propTypes.default.number.isRequired,
  isReseller: _propTypes.default.bool
};
CurrencySelector.defaultProps = {
  eidPrefix: 'uxp.hyd'
};
var _default = CurrencySelector;
/**
 * Internal helper component for displaying a single currency in the
 * CurrencySelector dropdown.
 *
 * @param {Object} props Properties
 * @returns {React.ReactNode} react component
 * @api private
 */
exports.default = _default;
function CurrencyItem(_ref) {
  let {
    code,
    symbol,
    eidPrefix,
    onClick,
    className
  } = _ref;
  /**
   * Invokes this.props.onClick with the code and symbol
   * of the currency associated with this instance.
   *
   * @param {React.SyntheticEvent} evt React Click event.
   */
  function _onClick(evt) {
    onClick(evt, {
      code,
      symbol
    });
  }
  const eid = (0, _golfToEid.default)(code, {
    prefix: eidPrefix + '.currency_selector',
    postfix: 'click'
  });
  const ariaLabelCurrency = code + ', ' + symbol;
  return /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: className,
    onClick: _onClick,
    "data-eid": eid,
    "aria-label": ariaLabelCurrency
  }, /*#__PURE__*/_react.default.createElement("span", null, code), " ", /*#__PURE__*/_react.default.createElement("span", null, symbol));
}

/*
 * PropTypes for the CurrencySelector.
 * Only `className` is optional.
 */
CurrencyItem.propTypes = {
  className: _propTypes.default.string,
  eidPrefix: _propTypes.default.string.isRequired,
  code: _propTypes.default.string.isRequired,
  symbol: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired
};